import { IPixStatusRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisPixStatusRepository from './implementations/VectisPixStatusRepository';

let instance: IPixStatusRepository | null = null;

export default function makePixStatusRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisPixStatusRepository(httpProvider);
  }

  return instance;
}
